import { Checkbox } from "@fluentui/react";
import React from "react";
import { linksCreate, linksUpdate } from "../../../api/api";
import { useFavoriteLinks } from "../../../state/api/links/useFavoriteLinks";
import { useLinks } from "../../../state/api/links/useLinks";
import { Doc } from "../../../types/db/collections";
import { GetLinkResponse, Link } from "../../../types/db/schema/links/link.schema";
import Button from "../buttons/Button";
import Submit from "../buttons/Submit";
import FieldWithLabel from "../formik/FieldWithLabel";
import { Dialog, DialogBody, DialogFooter, ModalForm } from "../modal/ModalForm";
import AsAdmin from "../session/AsAdmin";

interface Props {
  parent?: Doc<GetLinkResponse>;
  link?: Doc<GetLinkResponse>;

}

export default function LinkDialog(props: Props) {

  const { parent, link } = props;

  if (parent?.target) {
    return null;
  }

  return (
    <AsAdmin>
      <Dialog
        trigger={(
          <Button
            text={link?._id ? "Edit" : (parent ? "Add child" : "Create Link")}
            icon={link?._id ? "pen" : "plus"}
            size={link?._id || parent ? "small" : "regular"}
          />
        )}
        dialog={<LinkDialogInner {...props} />}
      />
    </AsAdmin>
  )
}

function LinkDialogInner(props: Props) {

  const { link, parent } = props;

  const [isFolder, setIsFolder] = React.useState(!!link?.children?.length || !link?.target);

  const { mutate: mutateLinks } = useLinks({ enabled: false });
  const { mutate: mutateFavoriteLinks } = useFavoriteLinks({ enabled: false });


  return (
    <ModalForm
      title={link?._id ? "Edit Link" : "Create Link"}
      description={link?._id ? "Edit existing Link" : (parent ? `Add Child Link to '${parent.label.substring(0, 20)}'` : "Create new Link or Link group")}
      initialValues={{
        description: "",
        target: "",
        parent: parent?._id || null,
        label: "",
        tags: "",
        ...link
      } as Link}
      onSubmit={async (values, callApi) => {

        const res = await callApi(
          link?._id
            ? linksUpdate(values as Doc<Link>)
            : linksCreate(values as Link)
        );

        if (!res?.success) {
          return false;
        }

        await mutateLinks();
        await mutateFavoriteLinks();

        return true;
      }}
    >
      {
        ({ values, setFieldValue }) => (
          <>
            <DialogBody>
              <FieldWithLabel name="label" label="Label" />
              <div className="d-flex flex-column w-100 gap-1">
                <label>Status</label>
                <Checkbox
                  styles={{ checkbox: { height: "16px", width: "16px" } }}
                  onRenderLabel={() => <strong className="ms-1" style={{ fontSize: "11.5px", color: "var(--gray-900)" }}>Is Folder</strong>}
                  checked={isFolder}
                  onChange={(_, checked) => {
                    if (checked) {
                      setFieldValue("target", "");
                    }

                    setIsFolder(!!checked)
                  }}
                />
                {
                  isFolder && (
                    <span className="font-s" style={{ color: "var(--gray-600)" }}>
                      Folders are a collection of sub-links.
                    </span>
                  )
                }
              </div>
              {
                !isFolder && (
                  <div className="d-flex flex-column w-100 gap-1">
                    <FieldWithLabel name="target" label="Target URL" />
                    <em style={{ fontSize: "0.75rem" }}>Don't forget https://...</em>
                  </div>

                )
              }
              <FieldWithLabel name="description" label="Description" as="textarea" />
              <FieldWithLabel name="tags" label="Tags (comma separated)" />
            </DialogBody>
            <DialogFooter>
              <Submit />
            </DialogFooter>
          </>
        )
      }
    </ModalForm>
  )
}